import React from "react";
import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  TextField,
  Typography,
} from "@mui/material";

const QuestionRenderer = ({
  question,
  selectedLanguage,
  selectedOptionId,
  selectedOptionIds,
  inputAnswer,
  handleOptionChange,
  handleMultipleChoiceChange,
  handleInputChange,
}) => {
  
  return (
    <FormControl component="fieldset" fullWidth>
      {question?.question_type === "Single" && (
        <RadioGroup
          value={selectedOptionId || ""}
          onChange={handleOptionChange}
          sx={{justifyContent:'space-between',flexDirection:'row !important'  }}
        >
          {question?.options?.map((option, idx) => (
            <FormControlLabel
              key={option.id}
              value={option.id}
              control={<Radio />}
              sx={{ width: "23%" }}
              label={
                <div style={{ display: "inline-flex", alignItems: "center" }}>
                  {/* <strong>{idx + 1}</strong>) */}
                  {selectedLanguage === "english" ? (
                    <span dangerouslySetInnerHTML={{ __html: option.option_en }} />
                  ) : (
                    <span dangerouslySetInnerHTML={{ __html: option.option_in }} />
                  )}
                </div>
              }
            />
          ))}
        </RadioGroup>
      )}

      {question?.question_type === "Multiple Choice" && (
        <div 
        style={{display:'inline-flex',justifyContent:'space-between'}}
        >
          {question?.options?.map((option, idx) => (
            <FormControlLabel
              key={option.id}
              control={
                <Checkbox
                  checked={selectedOptionIds.includes(option.id)}
                  onChange={(e) => handleMultipleChoiceChange(e, option.id)}
                  // sx={{ width: "20%" }}
                />
              }
              label={
                <div style={{ display: "flex", alignItems: "center" }}>
                  {/* <strong>{idx + 1}</strong>) */}
                  {selectedLanguage === "english" ? (
                    <span dangerouslySetInnerHTML={{ __html: option.option_en }} />
                  ) : (
                    <span dangerouslySetInnerHTML={{ __html: option.option_in }} />
                  )}
                </div>
              }
            />
          ))}
        </div>
      )}

      {(question?.question_type === "Fill In The Blanks"||question?.question_type === "Range") && (
        <TextField
          value={inputAnswer}
          onChange={handleInputChange}
          variant="outlined"
          // fullWidth
          sx={{ width: "250px", margin: "20px 0px" }}
          placeholder="Your Answer"
        />
      )}
    </FormControl>
  );
};

export default QuestionRenderer;
